import { render, staticRenderFns } from "./CatalogSelectionSuccess.vue?vue&type=template&id=032cfb8b&"
import script from "./CatalogSelectionSuccess.vue?vue&type=script&lang=ts&"
export * from "./CatalogSelectionSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports